import { useTranslation } from "react-i18next";
import { ReservedParticipationType } from "../../../../../autogen/bff-api";

// The bare `SHELTERED_WORKSHOP` enum key is shared with SupplierDeclarationType,
// whose translation is the long ESPD self-declaration question. Mapping to
// `reservedParticipation.*` keys keeps the buyer-side label decoupled from it.
export const useReservedParticipationLabel = () => {
  const { t } = useTranslation();
  return (value: ReservedParticipationType): string => {
    switch (value) {
      case ReservedParticipationType.None:
        return t("reservedParticipation.NONE");
      case ReservedParticipationType.ShelteredWorkshop:
        return t("reservedParticipation.SHELTERED_WORKSHOP");
      case ReservedParticipationType.PublicServiceMission:
        return t("reservedParticipation.PUBLIC_SERVICE_MISSION");
    }
  };
};
